import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';

const useCostCenterColumn = ({ groupBy }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => {
    const costCenter = params.data?.costCenter;
    return costCenter ? `${costCenter.name || ''}${costCenter.identifier ? ` (${costCenter.identifier})` : ''}` : '';
  }, []);

  return useMemo(
    () => ({
      field: 'costCenter',
      headerName: t('costCenter'),
      width: 150,
      rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.COST_CENTER,
      cellClass: 'justify-start',
      valueGetter
    }),
    [t, groupBy, valueGetter]
  );
};

export default useCostCenterColumn;
